import React from 'react';
import {Link as RouterLink, withRouter, RouteComponentProps} from "react-router-dom";
import {Typography, Menu, Layout, Icon, Button} from 'antd';
import * as routes from "../constants/routes";
import {AuthUserContext} from '../firebase/AuthUserContext';
import {auth} from "../firebase";
import styles from "./BasicLayout.module.less"
import TemplateEditor from "../pages/Banner/TemplateEditor";
import withTracker from "../components/GA/withTracker";
import {IUser} from "../store/user/types";

const {Paragraph, } = Typography;
const {Header, Content, Sider, Footer} = Layout;
const {SubMenu} = Menu;

function MadeWithLove() {
    return (
        <Paragraph>
            {'Built with love by the '}
            <a href="https://remerge.io/">
                Remerge
            </a>
            {' team.'}
        </Paragraph>
    );
}

interface NavigationProps extends RouteComponentProps<any> {

}

interface AuthNavigationProps extends RouteComponentProps<any> {
    authUser: IUser
}

const NavigationAuth = withRouter((props: AuthNavigationProps) => {
    return (
        <Menu theme="dark" mode="inline" defaultSelectedKeys={[routes.HOME]} selectedKeys={[props.location.pathname]}>
            {/*<Menu.Item key={routes.HOME}>*/}
            {/*    <RouterLink to={routes.HOME}>*/}
            {/*        <Icon type="home"/>*/}
            {/*        <span>Home</span>*/}
            {/*    </RouterLink>*/}
            {/*</Menu.Item>*/}
            <Menu.Item key={routes.ADS}>
                <RouterLink to={routes.ADS}>
                    <Icon type="appstore-o"/>
                    <span>Ads</span>
                </RouterLink>
            </Menu.Item>

            <SubMenu
                key="/sub/{routes.BANNER_TEMPLATES}"
                title={
                    <span>
                      <Icon type="snippets"/>
                      <span>Banner Templates</span>
                    </span>
                }
            >
                <Menu.Item key={routes.BANNER_TEMPLATES}>
                    <RouterLink to={routes.BANNER_TEMPLATES}>
                        <Icon type="list"/>
                        <span>Template List</span>
                    </RouterLink>
                </Menu.Item>
                <Menu.Item key={routes.BANNER_TEMPLATE_NEW}>
                    <RouterLink to={routes.BANNER_TEMPLATE_NEW}>
                        <Icon type="new"/>
                        <span>New Template</span>
                    </RouterLink>
                </Menu.Item>
            </SubMenu>

            <Menu.Item key={routes.FILES}>
                <RouterLink to={routes.FILES}>
                    <Icon type="folder"/>
                    <span>Files</span>
                </RouterLink>
            </Menu.Item>

            {/*<Menu.Item key={routes.BANNERS}>*/}
            {/*    <RouterLink to={routes.BANNERS}>*/}
            {/*        <Icon type="appstore-o"/>*/}
            {/*        <span>Banners</span>*/}
            {/*    </RouterLink>*/}
            {/*</Menu.Item>*/}
            <Menu.Divider/>
        </Menu>
    )
});

const NavigationNonAuth = withRouter((props: NavigationProps) => {
    return (
        <Menu theme="dark" mode="inline" defaultSelectedKeys={[routes.HOME]} selectedKeys={[props.location.pathname]}>
            <Menu.Item key="3">
                <RouterLink to={routes.SIGN_IN}>
                    <Icon type="user"/>
                    <span>SignIn</span>
                </RouterLink>
            </Menu.Item>
        </Menu>
    )
});
export interface  IBasicLayoutProps {
    header?: React.ReactNode;
    sidebarTop?: React.ReactNode;
    sidebarBottom?: React.ReactNode;
    children?: React.ReactNode;
}
function BasicLayout(props: IBasicLayoutProps) {
    const [open, setOpen] = React.useState(true);
    const handleDrawerOpen = () => {
        setOpen(!open);
    };
    let rightClassName = styles.right;
    const templateEditor = withTracker(TemplateEditor);

    return (
        <Layout className={styles.rootLayout}>
            <Sider
                trigger={null}
                collapsible={true}
                collapsed={open}
                className={styles.sider}
            >

                <div className={styles.logo}>
                    <img src={process.env.PUBLIC_URL + '/static/img/logo.png'} />
                </div>

                {props.sidebarTop}

                <AuthUserContext.Consumer>
                    {({authUser}) => (authUser ? <NavigationAuth authUser={authUser}/> : <NavigationNonAuth/>)}
                </AuthUserContext.Consumer>

                {props.sidebarBottom}


                <div className={styles.bottomActions}>
                    <div>
                        <Icon className={styles.trigger} onClick={auth.doSignOut} type="logout"/>
                    </div>
                    <div>
                        <Icon
                            className={styles.trigger}
                            type={open ? 'menu-unfold' : 'menu-fold'}
                            onClick={handleDrawerOpen}
                        />
                    </div>
                </div>
            </Sider>

            <Layout className={open ? styles.layoutClose : styles.layoutOpen}>
                <Header style={{background: '#fff', padding: 0}}>


                    <div className={styles.header}>
                        {props.header}
                    </div>

                    <div className={rightClassName}>
                    </div>
                </Header>
                <Content className={styles.content}>
                    {props.children}
                </Content>
                <Footer style={{textAlign: 'center'}}>
                </Footer>
            </Layout>
        </Layout>
    );
}

export default BasicLayout;
